import { render, staticRenderFns } from "./Sending.vue?vue&type=template&id=2868a744&"
import script from "./Sending.vue?vue&type=script&lang=ts&"
export * from "./Sending.vue?vue&type=script&lang=ts&"
import style0 from "./Sending.vue?vue&type=style&index=0&id=2868a744&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports